import { Validators } from '@angular/forms';
import { BaseInput, BaseInputConstructor } from './base-input';

export type TogglesInputConstructor = Omit<BaseInputConstructor<string>, 'placeholder' | 'clearable' | 'pattern'>;

export class ToggleInput extends BaseInput<string> {
    override inputType = 'toggle';
    styleClass: string | undefined = '';
    trueValue = 'true';
    falseValue = 'false';

    constructor(options: TogglesInputConstructor) {
        super(options);

        if (options.required) {
            this.setValidators(Validators.requiredTrue);
        }
    }

    clone(): ToggleInput {
        return new ToggleInput(this.__internalConstructor__);
    }
}
